import React from 'react'


class TabsButtons extends React.Component {
    render() {

        const changeItem = (key) => {
            document.querySelectorAll('.tab .nav-item .nav-link').forEach((el, i) => {
                el.classList.remove('active')
                el.setAttribute('aria-selected', false)
                if (i === key) {
                    el.classList.add('active')
                    el.setAttribute('aria-selected', true)
                }
            })

            document.querySelectorAll('.tab .tab-content .tab-pane').forEach((el, i) => {
                el.classList.remove('active', 'show')
                if (i === key) {
                    el.classList.add('active', 'show')
                }
            })
        }


        return (

            <ul class='nav nav-tabs' role='tablist'>
                {
                    this.props.buttons.map((item, key) => {
                        return (

                            <li className='nav-item' role='presentation'>
                                <button
                                    class={`nav-link ${item.active === true ? 'active' : ''}`}
                                    data-bs-toggle='tab'
                                    role='tab'
                                    aria-selected={item.active}
                                    onClick={(e) => changeItem(key)}
                                >{item.title}</button>
                            </li>

                        )
                    })
                }
            </ul>

        )
    }
}

export default TabsButtons;